import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fi-sr-category",
  "use": "icon-fi-sr-category-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-fi-sr-category\">\r\n  <path d=\"m8,0h-3.5C2.015,0,0,2.015,0,4.5v3.5c0,1.105.895,2,2,2h6c1.105,0,2-.895,2-2V2c0-1.105-.895-2-2-2Zm6,10h6c1.105,0,2-.895,2-2v-3.5c0-2.485-2.015-4.5-4.5-4.5h-3.5c-1.105,0-2,.895-2,2v6c0,1.105.895,2,2,2Zm-6,2H2c-1.105,0-2,.895-2,2v3.5c0,2.485,2.015,4.5,4.5,4.5h3.5c1.105,0,2-.895,2-2v-6c0-1.105-.895-2-2-2Zm15.707,10.293l-2.54-2.54c.524-.791.833-1.736.833-2.753,0-2.757-2.243-5-5-5s-5,2.243-5,5,2.243,5,5,5c1.017,0,1.962-.309,2.753-.833l2.54,2.54c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023,0-1.414Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fi-sr-category.svg
// module id = 3oPG
// module chunks = 63